<div class="d-flex flex-column vh-100 p-3 pb-5-sa">
    <div class="flex-grow-0">
        <span class="contract-list-header">
            <a class="btn-close d-flex justify-content-end mt-2 mr-2 mt-md-4 mr-lg-3"
                (click)="dismiss()"
                data-modal="dismiss()">
                <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
            </a>
        </span>
    </div>

    <div
        scrollListItem
        [highlightClassName]="'consumption-type-selected'"
        [scrollDisabled]="isListening"
        [decreaseOpacity]="true"
        [blockedPositionWithElementHeight]="true"
        class="flex-grow-1 text-center d-flex flex-column justify-content-end">
        <ul
            #meterList
            class="w-100 list-unstyled p-0 my-auto">
            <li
                [ngClass]="{ 'consumption-type-selected': isFirst }"
                [attr.active-element]="isFirst"
                class="consumption-type ng-star-inserted"
                *ngFor="let type of readingTypes; first as isFirst">
                <span title="typeTitle">{{ type.RegisterTypeStr | uppercase}}
                    <span title="typeNewReading">{{ type.reading !== "..." ? type.reading : null }}</span>
                </span>
                <span title="typeReading" class="reading">{{ type.reading }}</span>
                <ng-container *ngIf="!type.outOfBounds">
                    <span title="typeLastReading" class="readings-message last-reading">
                        {{ 'pt.edp.edponline.dashboard.widget.consumptions.last.reading' | translate }} {{ type.lastReading }}
                    </span>
                </ng-container>
                <ng-container *ngIf="type.outOfBounds">
                    <span title="typeLastReading" class="readings-message wrong-reading">
                        {{ 'pt.edp.edponline.dashboard.widget.consumptions.outSideConsumptions' | translate }}
                        ({{ 'pt.edp.edponline.dashboard.widget.consumptions.last.reading' | translate }} {{ type.lastReading }})
                    </span>
                </ng-container>
            </li>
        </ul>

        <div class="d-flex">
            <div [@btnMic]="(!isListening && readingsValidation) ? 'final' : 'initial'"
                class="btn icon-mic p-0 d-flex align-items-center justify-content-center"
                [ngClass]="{'icon-mic-selected': isListening}">
                <i
                    class="icon-edponline-Bop-171 icon-2x"
                    (click)="onMicPush()"  aria-hidden="true"></i>
            </div>
            <button
                (click)="onSubmitReading()"
                [@btnSendReading]="(!isListening && readingsValidation) ? 'final' : 'initial'"
                class="btn edp-btn-primary flex-fill ml-4 btnSendReadings">
                <span *ngIf="!activeMetersElectricity.updateReadingInTime &&
                    !activeMetersElectricity.updateReadingOutTime">{{
                    'ContractReadings.sendreading' | translate }}</span>
                <span *ngIf="activeMetersElectricity.updateReadingInTime ||
                    activeMetersElectricity.updateReadingOutTime">
                    {{'pt.edp.edponline.dashboard.widget.consumptions.updateConsumptions'
                    | translate }} </span>
            </button>
        </div>

        <div class="w-100 mt-3" style="min-height: 50px;">
            <span class="span-instructions">
                {{ this.tryAgain ? ('pt.edp.edponline.dashboard.widget.consumptions.voice.try.again' | translate) :
                    this.isListening && this.iOSdevice ? ('pt.edp.edponline.dashboard.widget.consumptions.voice.speak.now.ios' | translate) :
                    this.isListening && !this.iOSdevice ? ('pt.edp.edponline.dashboard.widget.consumptions.voice.speak.now' | translate) :
                    (
                        this.readingsValidation ?
                        ('pt.edp.edponline.dashboard.widget.consumptions.voice.confirm.entered.reading' | translate) :
                        ('pt.edp.edponline.dashboard.widget.consumptions.voice.press.micro.say.numbers' | translate)
                    )
                }}
            </span>
        </div>
    </div>
</div>